import { useReport } from "../../context/report";

import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';

export const PontosPrimeiraQualidade = () => {
    const { data } = useReport();

    const formatNumber = (rowData, props) => {
        return Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(rowData[props.field]);
    }

    return (
        <div>
            <h4>Relatório Pontos na 1º Qualidade</h4>
            <h4>Período - {data.periodo}</h4>

            <DataTable
                className="p-mt-2 p-mb-2"
                responsiveLayout="scroll"
                size="small"
                value={data.turma_grupo}
            >
                <Column header="TURMA" field="turma" sortable />
                {data.grupos.map((grupo, index) => (
                    <Column key={`column${index}`} header={"GRUPO " + grupo.grupo} body={(rowData) => (
                        <span>
                            {Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2 }).format(rowData['grupo' + grupo.grupo])}
                        </span>
                    )} />
                ))}
                <Column header="TOTAL PONTOS" field="total_pontos" body={formatNumber} sortable />
                <Column header="TOTAL (m)" field="total_metros" body={formatNumber} sortable />
            </DataTable>

            <hr></hr>

            <DataTable
                className="p-mt-1"
                footer={() => (
                    <div className="p-d-flex p-flex-row p-jc-around">
                        <h3 className="m-1 p-0">Pontos: {data.total_pontos}</h3>
                        <h3 className="m-1 p-0">Metros: {data.total_metros}</h3>
                    </div>
                )}
                responsiveLayout="scroll"
                size="small"
                value={data.dados}
            >
                <Column header="COD" field="cod_defeito" sortable />
                <Column header="DESCRIÇÃO" field="descricao" sortable />
                <Column header="VALOR" field="valor_defeito" sortable />
                <Column header="TURMA" field="turma" sortable />
                <Column header="GRUPO" field="grupo" sortable />
                <Column header="(m)" field="soma" body={formatNumber} sortable />
                <Column header="TEAR" field="tear" sortable />
            </DataTable>
        </div>
    )
}